import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './SubstitutionCreateScreen';
import SubstitutionCreate from './SubstitutionCreateScreen';
import { StoreState } from 'src/store/reducers';
import { selectNameProviders } from 'src/store/selectors/providers-selectors';
import { QueryParams } from '../../../../../../types/grid';
import { getSeances } from '../../../../../../store/actions/seance-actions';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';
import { getFormValues } from 'redux-form';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        inProgress: state.substitutions.inProgress,
        //     inProgressProvider: state.providers.inProgress,
        providers: selectNameProviders(state),
        valuesForm: getFormValues('substitution-form')(state),
        data: state.seances.data,

        inProgressSeance: state.seances.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),

        getData: (params: QueryParams) => dispatch(getSeances(params)),
    };
}

const SubstitutionCreateScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(SubstitutionCreate);

export default SubstitutionCreateScreen;
